<template>
  <main id="create-item-page" class="page-container">
    <!-- messaggi di stato -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <form class="create-item-form" @submit.prevent="onUpdateOutstock">
      <!-- riga base -->
      <div class="create-item-row row-1">
        <div v-if="form.subCategory === 'piastrelle'" class="field">
          <label for="item-name">Nome articolo *</label>
          <input
            id="item-name"
            type="text"
            v-model.trim="form.itemName"
            placeholder="es. Wall White"
          />
        </div>

        <div class="field">
          <label for="brandTile">Brand</label>
          <input
            id="brandTile"
            type="text"
            v-model="form.brand"
            placeholder="es. Cesame"
          />
        </div>

        <div v-if="form.subCategory === 'piastrelle'" class="field">
          <label for="widthCm">Larghezza (cm)</label>
          <input
            id="widthCm"
            type="number"
            v-model.number="form.widthCm"
            placeholder="es. 50"
          />
        </div>

        <div v-if="form.subCategory === 'piastrelle'" class="field">
          <label for="heightCm">Altezza (cm)</label>
          <input
            id="heightCm"
            type="number"
            v-model.number="form.heightCm"
            placeholder="es. 50"
          />
        </div>

        <!-- sotto i due campi width/height -->
        <small v-if="isTiles && measurePreview" class="measure-preview">
          Anteprima misura: {{ measurePreview }}
        </small>

        <div
          v-if="form.subCategory === 'sanitari' || form.subCategory === 'altro'"
          class="field"
        >
          <label for="subBrandTile">Modello</label>
          <input
            id="subBrandTile"
            type="text"
            v-model="form.subBrand"
            placeholder="es. GRAN MASCALZONE"
          />
        </div>
      </div>

      <hr />

      <div class="create-item-row row-2">
        <div class="field">
          <label for="item-quantity">Quantità ordinata totale</label>
          <input
            id="item-quantity"
            type="number"
            v-model.number="displayQuantity"
            min="0"
            placeholder="es. 100"
          />
        </div>

        <div class="field">
          <label for="item-price">Prezzo (€)</label>
          <input
            id="item-price"
            type="number"
            v-model.number="displayPrice"
            min="0"
            step="0.01"
            placeholder="€0.00"
          />
        </div>
      </div>

      <!-- submit -->
      <div class="save-button-container">
        <button
          id="create-item-button"
          type="submit"
          :disabled="!canSubmit"
          :aria-disabled="!canSubmit"
          :title="
            !canSubmit
              ? 'Modifica almeno uno dei campi'
              : 'Aggiorna articolo fuori magazzino'
          "
        >
          Aggiorna
        </button>
      </div>
    </form>
  </main>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.cjs.js";

export default {
  name: "EditOutstockPage",
  props: ["outstockId"],
  data() {
    return {
      errorMessage: "",
      successMessage: "",
      originalSig: "",
      form: {
        itemName: "",
        sqmQuantity: 0,
        quantity: 0,
        category: "",
        brand: "",
        subBrand: "",
        price: 0,
        sqmPrice: 0,
        subCategory: "",
        widthCm: "",
        heightCm: "",
      },
    };
  },
  computed: {
    isTiles() {
      return (this.form.subCategory || "").toLowerCase() === "piastrelle";
    },
    isSanAlt() {
      return (
        this.form.subCategory === "sanitari" ||
        this.form.subCategory === "altro"
      );
    },
    // ✅ c’è una modifica rispetto ai dati originali?
    isDirty() {
      return this.computeSignature(this.form) !== this.originalSig;
    },

    // ✅ validazione come prima
    isValid() {
      if (!this.form.subCategory) return false;

      if (this.isTiles) {
        const nameOk = (this.form.itemName || "").trim().length > 0;
        const qtyOk =
          Number.isFinite(+this.form.sqmQuantity) &&
          +this.form.sqmQuantity >= 0; // ✅ 0 permesso
        const priceOk =
          Number.isFinite(+this.form.sqmPrice) && +this.form.sqmPrice > 0;
        return nameOk && qtyOk && priceOk;
      }

      if (this.isSanAlt) {
        const brandOk = (this.form.brand || "").trim().length > 0;
        const subBrandOk =
          (this.form.subBrand || "").trim().length > 0 ||
          this.form.subCategory === "altro";
        const priceOk =
          Number.isFinite(+this.form.price) && +this.form.price > 0;
        return brandOk && subBrandOk && priceOk;
      }

      return false;
    },

    // 🔒 bottone abilitato solo se valido **e** modificato
    canSubmit() {
      return this.isValid && this.isDirty;
    },

    measurePreview() {
      if (!this.isTiles) return "";
      const w = Number(this.form.widthCm);
      const h = Number(this.form.heightCm);
      if (Number.isFinite(w) && Number.isFinite(h) && w > 0 && h > 0) {
        return `${h}x${w} cm`;
      }
      return "";
    },

    displayPrice: {
      get() {
        return this.isTiles ? this.form.sqmPrice : this.form.price;
      },
      set(val) {
        if (this.isTiles) this.form.sqmPrice = val ?? 0;
        else this.form.price = val ?? 0;
      },
    },
    displayQuantity: {
      get() {
        return this.isTiles ? this.form.sqmQuantity : this.form.quantity;
      },
      set(val) {
        if (this.isTiles) this.form.sqmQuantity = val ?? 0;
        else this.form.quantity = val ?? 0;
      },
    },
  },
  methods: {
    ...mapActions(["updateOutstock"]),

    // 🔧 normalizza solo i campi che contano davvero per il confronto
    normalizeForCompare(src) {
      const s = src || {};
      const base = {
        category: (s.category || "").toLowerCase(),
        subCategory: (s.subCategory || "").toLowerCase(),
      };

      if ((base.subCategory || "") === "piastrelle") {
        return {
          ...base,
          itemName: (s.itemName || "").trim(),
          brand: (s.brand || "").trim(),
          subBrand: (s.subBrand || "").trim(),
          sqmQuantity: Number(s.sqmQuantity) || 0,
          sqmPrice: Number(s.sqmPrice) || 0,
          widthCm: s.widthCm || "",
          heightCm: s.heightCm || "",
        };
      }

      // sanitari/altro
      return {
        ...base,
        brand: (s.brand || "").trim(),
        subBrand: (s.subBrand || "").trim(),
        quantity: Number(s.quantity) || 0,
        price: Number(s.price) || 0,
      };
    },

    computeSignature(src) {
      // stringify stabile
      return JSON.stringify(this.normalizeForCompare(src));
    },

    // helper per parsare measureDesc
    parseMeasureDesc(desc) {
      if (!desc || typeof desc !== "string") return { h: "", w: "" };
      // es. "50x50 cm", "50×50", "50 X 50", "50x50cm"
      const cleaned = desc
        .trim()
        .toLowerCase()
        .replace(/\s*cm\s*$/i, "");
      const m = cleaned.match(/^(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)$/i);
      if (!m) return { h: "", w: "" };
      const h = Number(m[1]);
      const w = Number(m[2]);
      return {
        h: Number.isFinite(h) ? h : "",
        w: Number.isFinite(w) ? w : "",
      };
    },

    async fetchOutstockData() {
      try {
        this.errorMessage = "";
        const response = await this.$axios.get(`/outstock/${this.outstockId}`);

        // console.log("Fetched outstock data:", response.data);
        if (response.status === 200) {
          const outstockData = response.data.outstock;
          this.form = { ...outstockData };

          // console.log("outstockData", outstockData);
          // console.log("this.form", this.form);

          // Se ha measureDesc, parsa e mostra negli input locali
          if (this.form.measureDesc) {
            const { h, w } = this.parseMeasureDesc(this.form.measureDesc);
            this.form.heightCm = h;
            this.form.widthCm = w;
          } else {
            this.form.heightCm = this.form.heightCm ?? "";
            this.form.widthCm = this.form.widthCm ?? "";
          }

          // salva la firma ORIGINALE per i confronti futuri
          this.originalSig = this.computeSignature(this.form);

          this.successMessage =
            response.data?.message ||
            `Articolo fuori magazzino con ID ${outstockData.id} caricato!`;

          this.$toast.success(this.successMessage);
        }
      } catch (error) {
        this.errorMessage =
          error.response?.data?.message ||
          "Errore nel caricamento dei dati dell'articolo fuori magazzino.";
        this.$toast.error(this.errorMessage);
      }
    },

    async onUpdateOutstock() {
      this.errorMessage = "";
      this.successMessage = "";

      try {
        const payload = { ...this.form };
        // console.log("payload", payload);

        // NON mandare measureDesc: lo ricalcola il server
        delete payload.measureDesc;

        if (this.isTiles) {
          const w = Number(payload.widthCm);
          const h = Number(payload.heightCm);
          if (!(Number.isFinite(w) && Number.isFinite(h) && w > 0 && h > 0)) {
            // se non sono entrambi validi, li togliamo (così il server non ricalcola)
            delete payload.widthCm;
            delete payload.heightCm;
          }
        } else {
          delete payload.widthCm;
          delete payload.heightCm;
          delete payload.sqmQuantity;
          delete payload.sqmPrice;
        }

        const res = await this.$store.dispatch("updateOutstock", {
          outstockId: this.outstockId,
          payload,
        });

        if (res.status === 200) {
          const updatedOutstock = res.data?.outstock || {};
          // NEW: se il server ha ricalcolato measureDesc, aggiorna gli input
          if (updatedOutstock.measureDesc) {
            const { h, w } = this.parseMeasureDesc(updatedOutstock.measureDesc);
            this.form.heightCm = h;
            this.form.widthCm = w;
          }

          this.successMessage =
            res.data?.message || "Articolo fuori magazzino aggiornato!";
          this.$toast.success(this.successMessage);

          // dopo l’update, riallinea la firma (non più “dirty”)
          this.originalSig = this.computeSignature(this.form);

          // torna alla lista dopo 1 s
          setTimeout(() => this.$router.push({ name: "orders" }), 1000);
        }
      } catch (err) {
        this.errorMessage =
          err.response?.data?.details ||
          err.response?.data?.error ||
          "Errore durante l'aggiornamento dell'articolo fuori magazzino.";
        this.$toast.error(this.errorMessage);

        this.successMessage = "";
      }
    },
  },

  /** caricamento dati all’ingresso */
  mounted() {
    this.fetchOutstockData();
  },
};
</script>

<style src="@/css/CreateItemPage.css" />
